// Comprehensive ICD-10 codes used in home care
export const ICD10_CODES = [
  // Heart & Cardiovascular
  { code: "I50.9", description: "Heart failure, unspecified" },
  { code: "I50.1", description: "Left ventricular failure" },
  { code: "I50.20", description: "Unspecified systolic heart failure" },
  { code: "I50.21", description: "Acute systolic heart failure" },
  { code: "I50.22", description: "Chronic systolic heart failure" },
  { code: "I50.23", description: "Acute on chronic systolic heart failure" },
  { code: "I50.30", description: "Unspecified diastolic heart failure" },
  { code: "I50.31", description: "Acute diastolic heart failure" },
  { code: "I50.32", description: "Chronic diastolic heart failure" },
  { code: "I50.33", description: "Acute on chronic diastolic heart failure" },
  { code: "I50.40", description: "Unspecified combined systolic and diastolic heart failure" },
  { code: "I50.41", description: "Acute combined systolic and diastolic heart failure" },
  { code: "I50.42", description: "Chronic combined systolic and diastolic heart failure" },
  { code: "I50.43", description: "Acute on chronic combined systolic and diastolic heart failure" },
  { code: "I10", description: "Essential (primary) hypertension" },
  { code: "I11.0", description: "Hypertensive heart disease with heart failure" },
  { code: "I11.9", description: "Hypertensive heart disease without heart failure" },
  { code: "I12.9", description: "Hypertensive chronic kidney disease with stage 1-4 CKD" },
  { code: "I13.0", description: "Hypertensive heart and CKD with heart failure and stage 1-4 CKD" },
  { code: "I13.10", description: "Hypertensive heart and CKD without heart failure, with stage 1-4 CKD" },
  { code: "I25.10", description: "Atherosclerotic heart disease of native coronary artery" },
  { code: "I25.110", description: "Atherosclerotic heart disease with unstable angina" },
  { code: "I25.111", description: "Atherosclerotic heart disease with angina pectoris with documented spasm" },
  { code: "I25.118", description: "Atherosclerotic heart disease with other forms of angina pectoris" },
  { code: "I25.119", description: "Atherosclerotic heart disease with unspecified angina pectoris" },
  { code: "I25.2", description: "Old myocardial infarction" },
  { code: "I25.5", description: "Ischemic cardiomyopathy" },
  { code: "I25.9", description: "Chronic ischemic heart disease, unspecified" },
  { code: "I48.0", description: "Paroxysmal atrial fibrillation" },
  { code: "I48.1", description: "Persistent atrial fibrillation" },
  { code: "I48.2", description: "Chronic atrial fibrillation" },
  { code: "I48.91", description: "Unspecified atrial fibrillation" },
  { code: "I48.92", description: "Unspecified atrial flutter" },
  { code: "I63.9", description: "Cerebral infarction, unspecified (Stroke)" },
  { code: "I63.50", description: "Cerebral infarction due to unspecified occlusion of unspecified cerebral artery" },
  { code: "I69.30", description: "Unspecified sequelae of cerebral infarction" },
  { code: "I69.31", description: "Cognitive deficits following cerebral infarction" },
  { code: "I69.32", description: "Speech and language deficits following cerebral infarction" },
  { code: "I69.33", description: "Monoplegia of upper limb following cerebral infarction" },
  { code: "I69.34", description: "Monoplegia of lower limb following cerebral infarction" },
  { code: "I69.35", description: "Hemiplegia following cerebral infarction" },
  { code: "I69.36", description: "Other paralytic syndrome following cerebral infarction" },
  { code: "I69.39", description: "Other sequelae of cerebral infarction" },
  { code: "I70.0", description: "Atherosclerosis of aorta" },
  { code: "I70.209", description: "Unspecified atherosclerosis of native arteries of extremities, unspecified extremity" },
  { code: "I73.9", description: "Peripheral vascular disease, unspecified" },
  { code: "I87.2", description: "Venous insufficiency (chronic) (peripheral)" },
  
  // Diabetes
  { code: "E11.9", description: "Type 2 diabetes mellitus without complications" },
  { code: "E11.00", description: "Type 2 diabetes with hyperosmolarity without coma" },
  { code: "E11.21", description: "Type 2 diabetes with diabetic nephropathy" },
  { code: "E11.22", description: "Type 2 diabetes with diabetic chronic kidney disease" },
  { code: "E11.29", description: "Type 2 diabetes with other diabetic kidney complication" },
  { code: "E11.311", description: "Type 2 diabetes with unspecified diabetic retinopathy with macular edema" },
  { code: "E11.319", description: "Type 2 diabetes with unspecified diabetic retinopathy without macular edema" },
  { code: "E11.36", description: "Type 2 diabetes with diabetic cataract" },
  { code: "E11.40", description: "Type 2 diabetes with diabetic neuropathy, unspecified" },
  { code: "E11.41", description: "Type 2 diabetes with diabetic mononeuropathy" },
  { code: "E11.42", description: "Type 2 diabetes with diabetic polyneuropathy" },
  { code: "E11.43", description: "Type 2 diabetes with diabetic autonomic (poly)neuropathy" },
  { code: "E11.44", description: "Type 2 diabetes with diabetic amyotrophy" },
  { code: "E11.51", description: "Type 2 diabetes with diabetic peripheral angiopathy without gangrene" },
  { code: "E11.52", description: "Type 2 diabetes with diabetic peripheral angiopathy with gangrene" },
  { code: "E11.59", description: "Type 2 diabetes with other circulatory complications" },
  { code: "E11.610", description: "Type 2 diabetes with diabetic neuropathic arthropathy" },
  { code: "E11.618", description: "Type 2 diabetes with other diabetic arthropathy" },
  { code: "E11.620", description: "Type 2 diabetes with diabetic dermatitis" },
  { code: "E11.621", description: "Type 2 diabetes with foot ulcer" },
  { code: "E11.622", description: "Type 2 diabetes with other skin ulcer" },
  { code: "E11.628", description: "Type 2 diabetes with other skin complications" },
  { code: "E11.630", description: "Type 2 diabetes with periodontal disease" },
  { code: "E11.638", description: "Type 2 diabetes with other oral complications" },
  { code: "E11.641", description: "Type 2 diabetes with hypoglycemia with coma" },
  { code: "E11.649", description: "Type 2 diabetes with hypoglycemia without coma" },
  { code: "E11.65", description: "Type 2 diabetes with hyperglycemia" },
  { code: "E11.69", description: "Type 2 diabetes with other specified complication" },
  { code: "E11.8", description: "Type 2 diabetes with unspecified complications" },
  { code: "E10.9", description: "Type 1 diabetes mellitus without complications" },
  { code: "E10.10", description: "Type 1 diabetes with ketoacidosis without coma" },
  { code: "E10.21", description: "Type 1 diabetes with diabetic nephropathy" },
  { code: "E10.40", description: "Type 1 diabetes with diabetic neuropathy, unspecified" },
  { code: "E10.65", description: "Type 1 diabetes with hyperglycemia" },
  { code: "E13.9", description: "Other specified diabetes mellitus without complications" },
  
  // Respiratory
  { code: "J44.9", description: "COPD, unspecified" },
  { code: "J44.0", description: "COPD with acute lower respiratory infection" },
  { code: "J44.1", description: "COPD with acute exacerbation" },
  { code: "J43.9", description: "Emphysema, unspecified" },
  { code: "J45.20", description: "Mild intermittent asthma, uncomplicated" },
  { code: "J45.30", description: "Mild persistent asthma, uncomplicated" },
  { code: "J45.40", description: "Moderate persistent asthma, uncomplicated" },
  { code: "J45.50", description: "Severe persistent asthma, uncomplicated" },
  { code: "J45.909", description: "Unspecified asthma, uncomplicated" },
  { code: "J18.9", description: "Pneumonia, unspecified organism" },
  { code: "J15.9", description: "Unspecified bacterial pneumonia" },
  { code: "J12.9", description: "Viral pneumonia, unspecified" },
  { code: "J69.0", description: "Aspiration pneumonia due to food and vomit" },
  { code: "J96.10", description: "Chronic respiratory failure, unspecified whether with hypoxia or hypercapnia" },
  { code: "J96.11", description: "Chronic respiratory failure with hypoxia" },
  { code: "J96.12", description: "Chronic respiratory failure with hypercapnia" },
  { code: "J96.20", description: "Acute and chronic respiratory failure, unspecified" },
  { code: "J84.10", description: "Pulmonary fibrosis, unspecified" },
  { code: "J84.9", description: "Interstitial pulmonary disease, unspecified" },
  { code: "J98.4", description: "Other disorders of lung" },
  { code: "Z99.11", description: "Dependence on respiratory ventilator" },
  { code: "Z99.81", description: "Dependence on supplemental oxygen" },
  
  // Neurological
  { code: "G20", description: "Parkinson's disease" },
  { code: "G21.11", description: "Neuroleptic induced parkinsonism" },
  { code: "G30.0", description: "Alzheimer's disease with early onset" },
  { code: "G30.1", description: "Alzheimer's disease with late onset" },
  { code: "G30.9", description: "Alzheimer's disease, unspecified" },
  { code: "G31.01", description: "Pick's disease" },
  { code: "G31.09", description: "Other frontotemporal dementia" },
  { code: "G31.83", description: "Dementia with Lewy bodies" },
  { code: "G31.84", description: "Mild cognitive impairment" },
  { code: "G35", description: "Multiple sclerosis" },
  { code: "G40.909", description: "Epilepsy, unspecified, not intractable, without status epilepticus" },
  { code: "G40.919", description: "Epilepsy, unspecified, intractable, without status epilepticus" },
  { code: "G43.909", description: "Migraine, unspecified, not intractable, without status migrainosus" },
  { code: "G47.33", description: "Obstructive sleep apnea" },
  { code: "G62.9", description: "Polyneuropathy, unspecified" },
  { code: "G71.0", description: "Muscular dystrophy" },
  { code: "G80.9", description: "Cerebral palsy, unspecified" },
  { code: "G81.90", description: "Hemiplegia, unspecified affecting unspecified side" },
  { code: "G81.91", description: "Hemiplegia, unspecified affecting right dominant side" },
  { code: "G81.92", description: "Hemiplegia, unspecified affecting left dominant side" },
  { code: "G81.93", description: "Hemiplegia, unspecified affecting right nondominant side" },
  { code: "G81.94", description: "Hemiplegia, unspecified affecting left nondominant side" },
  { code: "G82.20", description: "Paraplegia, unspecified" },
  { code: "G82.50", description: "Quadriplegia, unspecified" },
  { code: "G83.4", description: "Cauda equina syndrome" },
  { code: "G89.29", description: "Other chronic pain" },
  { code: "G89.4", description: "Chronic pain syndrome" },
  
  // Mental Health & Cognitive
  { code: "F01.50", description: "Vascular dementia without behavioral disturbance" },
  { code: "F01.51", description: "Vascular dementia with behavioral disturbance" },
  { code: "F02.80", description: "Dementia in other diseases classified elsewhere without behavioral disturbance" },
  { code: "F02.81", description: "Dementia in other diseases classified elsewhere with behavioral disturbance" },
  { code: "F03.90", description: "Unspecified dementia without behavioral disturbance" },
  { code: "F03.91", description: "Unspecified dementia with behavioral disturbance" },
  { code: "F05", description: "Delirium due to known physiological condition" },
  { code: "F06.0", description: "Psychotic disorder with hallucinations due to known physiological condition" },
  { code: "F06.2", description: "Psychotic disorder with delusions due to known physiological condition" },
  { code: "F06.30", description: "Mood disorder due to known physiological condition, unspecified" },
  { code: "F06.31", description: "Mood disorder due to known physiological condition with depressive features" },
  { code: "F06.32", description: "Mood disorder due to known physiological condition with major depressive-like episode" },
  { code: "F06.33", description: "Mood disorder due to known physiological condition with manic features" },
  { code: "F06.34", description: "Mood disorder due to known physiological condition with mixed features" },
  { code: "F10.20", description: "Alcohol dependence, uncomplicated" },
  { code: "F10.21", description: "Alcohol dependence, in remission" },
  { code: "F17.210", description: "Nicotine dependence, cigarettes, uncomplicated" },
  { code: "F20.9", description: "Schizophrenia, unspecified" },
  { code: "F25.9", description: "Schizoaffective disorder, unspecified" },
  { code: "F31.9", description: "Bipolar disorder, unspecified" },
  { code: "F32.0", description: "Major depressive disorder, single episode, mild" },
  { code: "F32.1", description: "Major depressive disorder, single episode, moderate" },
  { code: "F32.2", description: "Major depressive disorder, single episode, severe without psychotic features" },
  { code: "F32.9", description: "Major depressive disorder, single episode, unspecified" },
  { code: "F33.0", description: "Major depressive disorder, recurrent, mild" },
  { code: "F33.1", description: "Major depressive disorder, recurrent, moderate" },
  { code: "F33.2", description: "Major depressive disorder, recurrent, severe without psychotic features" },
  { code: "F33.9", description: "Major depressive disorder, recurrent, unspecified" },
  { code: "F41.0", description: "Panic disorder without agoraphobia" },
  { code: "F41.1", description: "Generalized anxiety disorder" },
  { code: "F41.9", description: "Anxiety disorder, unspecified" },
  { code: "F43.10", description: "Post-traumatic stress disorder, unspecified" },
  { code: "F43.12", description: "Post-traumatic stress disorder, chronic" },
  
  // Musculoskeletal
  { code: "M54.5", description: "Low back pain" },
  { code: "M54.50", description: "Low back pain, unspecified" },
  { code: "M54.2", description: "Cervicalgia (neck pain)" },
  { code: "M54.16", description: "Radiculopathy, lumbar region" },
  { code: "M54.17", description: "Radiculopathy, lumbosacral region" },
  { code: "M47.816", description: "Spondylosis without myelopathy or radiculopathy, lumbar region" },
  { code: "M47.817", description: "Spondylosis without myelopathy or radiculopathy, lumbosacral region" },
  { code: "M51.16", description: "Intervertebral disc degeneration, lumbar region" },
  { code: "M17.0", description: "Primary osteoarthritis of knee, bilateral" },
  { code: "M17.10", description: "Unilateral primary osteoarthritis, unspecified knee" },
  { code: "M17.11", description: "Unilateral primary osteoarthritis, right knee" },
  { code: "M17.12", description: "Unilateral primary osteoarthritis, left knee" },
  { code: "M17.9", description: "Osteoarthritis of knee, unspecified" },
  { code: "M16.0", description: "Primary osteoarthritis of hip, bilateral" },
  { code: "M16.10", description: "Unilateral primary osteoarthritis, unspecified hip" },
  { code: "M16.11", description: "Unilateral primary osteoarthritis, right hip" },
  { code: "M16.12", description: "Unilateral primary osteoarthritis, left hip" },
  { code: "M16.9", description: "Osteoarthritis of hip, unspecified" },
  { code: "M19.90", description: "Unspecified osteoarthritis, unspecified site" },
  { code: "M79.3", description: "Panniculitis, unspecified" },
  { code: "M79.7", description: "Fibromyalgia" },
  { code: "M80.00XA", description: "Age-related osteoporosis with current pathological fracture, unspecified site, initial encounter" },
  { code: "M81.0", description: "Age-related osteoporosis without current pathological fracture" },
  { code: "M62.81", description: "Muscle weakness (generalized)" },
  { code: "M62.84", description: "Sarcopenia" },
  { code: "M05.79", description: "Rheumatoid arthritis with rheumatoid factor of multiple sites without organ or systems involvement" },
  { code: "M06.9", description: "Rheumatoid arthritis, unspecified" },
  
  // Wounds & Skin
  { code: "L89.90", description: "Pressure ulcer of unspecified site, unspecified stage" },
  { code: "L89.000", description: "Pressure ulcer of unspecified elbow, unstageable" },
  { code: "L89.009", description: "Pressure ulcer of unspecified elbow, unspecified stage" },
  { code: "L89.100", description: "Pressure ulcer of unspecified part of back, unstageable" },
  { code: "L89.109", description: "Pressure ulcer of unspecified part of back, unspecified stage" },
  { code: "L89.150", description: "Pressure ulcer of sacral region, unstageable" },
  { code: "L89.151", description: "Pressure ulcer of sacral region, stage 1" },
  { code: "L89.152", description: "Pressure ulcer of sacral region, stage 2" },
  { code: "L89.153", description: "Pressure ulcer of sacral region, stage 3" },
  { code: "L89.154", description: "Pressure ulcer of sacral region, stage 4" },
  { code: "L89.159", description: "Pressure ulcer of sacral region, unspecified stage" },
  { code: "L89.200", description: "Pressure ulcer of unspecified hip, unstageable" },
  { code: "L89.209", description: "Pressure ulcer of unspecified hip, unspecified stage" },
  { code: "L89.300", description: "Pressure ulcer of unspecified buttock, unstageable" },
  { code: "L89.309", description: "Pressure ulcer of unspecified buttock, unspecified stage" },
  { code: "L89.500", description: "Pressure ulcer of unspecified ankle, unstageable" },
  { code: "L89.509", description: "Pressure ulcer of unspecified ankle, unspecified stage" },
  { code: "L89.600", description: "Pressure ulcer of unspecified heel, unstageable" },
  { code: "L89.609", description: "Pressure ulcer of unspecified heel, unspecified stage" },
  { code: "L97.109", description: "Non-pressure chronic ulcer of unspecified thigh with unspecified severity" },
  { code: "L97.409", description: "Non-pressure chronic ulcer of unspecified heel and midfoot with unspecified severity" },
  { code: "L97.509", description: "Non-pressure chronic ulcer of other part of unspecified foot with unspecified severity" },
  { code: "L97.909", description: "Non-pressure chronic ulcer of unspecified site of unspecified lower extremity with unspecified severity" },
  { code: "T81.4XXA", description: "Infection following a procedure, initial encounter" },
  { code: "L03.90", description: "Cellulitis, unspecified" },
  { code: "L03.115", description: "Cellulitis of right lower limb" },
  { code: "L03.116", description: "Cellulitis of left lower limb" },
  { code: "L08.9", description: "Local infection of the skin and subcutaneous tissue, unspecified" },
  
  // Kidney & Urinary
  { code: "N18.1", description: "Chronic kidney disease, stage 1" },
  { code: "N18.2", description: "Chronic kidney disease, stage 2 (mild)" },
  { code: "N18.3", description: "Chronic kidney disease, stage 3 (moderate)" },
  { code: "N18.30", description: "Chronic kidney disease, stage 3 unspecified" },
  { code: "N18.31", description: "Chronic kidney disease, stage 3a" },
  { code: "N18.32", description: "Chronic kidney disease, stage 3b" },
  { code: "N18.4", description: "Chronic kidney disease, stage 4 (severe)" },
  { code: "N18.5", description: "Chronic kidney disease, stage 5" },
  { code: "N18.6", description: "End stage renal disease" },
  { code: "N18.9", description: "Chronic kidney disease, unspecified" },
  { code: "N17.9", description: "Acute kidney failure, unspecified" },
  { code: "N39.0", description: "Urinary tract infection, site not specified" },
  { code: "N30.00", description: "Acute cystitis without hematuria" },
  { code: "N30.01", description: "Acute cystitis with hematuria" },
  { code: "N39.41", description: "Urge incontinence" },
  { code: "N39.42", description: "Incontinence without sensory awareness" },
  { code: "N39.43", description: "Post-void dribbling" },
  { code: "N39.44", description: "Nocturnal enuresis" },
  { code: "N39.46", description: "Mixed incontinence" },
  { code: "N39.498", description: "Other specified urinary incontinence" },
  { code: "R32", description: "Unspecified urinary incontinence" },
  { code: "R33.9", description: "Retention of urine, unspecified" },
  { code: "Z93.6", description: "Other artificial openings of urinary tract status" },
  { code: "Z99.2", description: "Dependence on renal dialysis" },
  
  // Cancer / Oncology
  { code: "C80.1", description: "Malignant (primary) neoplasm, unspecified" },
  { code: "C34.90", description: "Malignant neoplasm of unspecified part of unspecified bronchus or lung" },
  { code: "C34.91", description: "Malignant neoplasm of unspecified part of right bronchus or lung" },
  { code: "C34.92", description: "Malignant neoplasm of unspecified part of left bronchus or lung" },
  { code: "C50.911", description: "Malignant neoplasm of unspecified site of right female breast" },
  { code: "C50.912", description: "Malignant neoplasm of unspecified site of left female breast" },
  { code: "C50.919", description: "Malignant neoplasm of unspecified site of unspecified female breast" },
  { code: "C18.9", description: "Malignant neoplasm of colon, unspecified" },
  { code: "C61", description: "Malignant neoplasm of prostate" },
  { code: "C67.9", description: "Malignant neoplasm of bladder, unspecified" },
  { code: "C78.00", description: "Secondary malignant neoplasm of unspecified lung" },
  { code: "C78.7", description: "Secondary malignant neoplasm of liver and intrahepatic bile duct" },
  { code: "C79.31", description: "Secondary malignant neoplasm of brain" },
  { code: "C79.51", description: "Secondary malignant neoplasm of bone" },
  { code: "Z85.3", description: "Personal history of malignant neoplasm of breast" },
  { code: "Z85.118", description: "Personal history of other malignant neoplasm of bronchus and lung" },
  { code: "Z85.038", description: "Personal history of other malignant neoplasm of large intestine" },
  { code: "Z85.46", description: "Personal history of malignant neoplasm of prostate" },
  
  // Post-surgical / Aftercare
  { code: "Z96.641", description: "Presence of right artificial hip joint" },
  { code: "Z96.642", description: "Presence of left artificial hip joint" },
  { code: "Z96.643", description: "Presence of artificial hip joint, bilateral" },
  { code: "Z96.651", description: "Presence of right artificial knee joint" },
  { code: "Z96.652", description: "Presence of left artificial knee joint" },
  { code: "Z96.653", description: "Presence of artificial knee joint, bilateral" },
  { code: "Z96.1", description: "Presence of intraocular lens" },
  { code: "Z95.0", description: "Presence of cardiac pacemaker" },
  { code: "Z95.1", description: "Presence of aortocoronary bypass graft" },
  { code: "Z95.2", description: "Presence of prosthetic heart valve" },
  { code: "Z95.5", description: "Presence of coronary angioplasty implant and graft" },
  { code: "Z95.810", description: "Presence of automatic (implantable) cardiac defibrillator" },
  { code: "Z48.00", description: "Encounter for change or removal of nonsurgical wound dressing" },
  { code: "Z48.01", description: "Encounter for change or removal of surgical wound dressing" },
  { code: "Z48.02", description: "Encounter for removal of sutures" },
  { code: "Z48.03", description: "Encounter for change or removal of drains" },
  { code: "Z48.812", description: "Encounter for surgical aftercare following surgery on the circulatory system" },
  { code: "Z48.813", description: "Encounter for surgical aftercare following surgery on the respiratory system" },
  { code: "Z48.814", description: "Encounter for surgical aftercare following surgery on the teeth or oral cavity" },
  { code: "Z48.815", description: "Encounter for surgical aftercare following surgery on the digestive system" },
  { code: "Z48.816", description: "Encounter for surgical aftercare following surgery on the genitourinary system" },
  { code: "Z48.817", description: "Encounter for surgical aftercare following surgery on the skin and subcutaneous tissue" },
  { code: "Z48.89", description: "Encounter for other specified surgical aftercare" },
  
  // Fractures
  { code: "S72.001A", description: "Fracture of unspecified part of neck of right femur, initial encounter" },
  { code: "S72.002A", description: "Fracture of unspecified part of neck of left femur, initial encounter" },
  { code: "S72.009A", description: "Fracture of unspecified part of neck of unspecified femur, initial encounter" },
  { code: "S72.90XA", description: "Unspecified fracture of unspecified femur, initial encounter" },
  { code: "S32.10XA", description: "Unspecified fracture of sacrum, initial encounter" },
  { code: "S22.9XXA", description: "Fracture of bony thorax, part unspecified, initial encounter" },
  { code: "M84.359A", description: "Stress fracture, hip, unspecified, initial encounter" },
  { code: "M84.750A", description: "Atypical femoral fracture, unspecified, initial encounter" },
  
  // Functional Limitations
  { code: "R26.0", description: "Ataxic gait" },
  { code: "R26.1", description: "Paralytic gait" },
  { code: "R26.2", description: "Difficulty in walking, not elsewhere classified" },
  { code: "R26.81", description: "Unsteadiness on feet" },
  { code: "R26.89", description: "Other abnormalities of gait and mobility" },
  { code: "R26.9", description: "Unspecified abnormalities of gait and mobility" },
  { code: "R27.0", description: "Ataxia, unspecified" },
  { code: "R27.8", description: "Other lack of coordination" },
  { code: "R27.9", description: "Unspecified lack of coordination" },
  { code: "R41.0", description: "Disorientation, unspecified" },
  { code: "R41.82", description: "Altered mental status, unspecified" },
  { code: "R41.840", description: "Attention and concentration deficit" },
  { code: "R41.841", description: "Cognitive communication deficit" },
  { code: "R41.843", description: "Psychomotor deficit" },
  { code: "R41.844", description: "Frontal lobe and executive function deficit" },
  { code: "R53.1", description: "Weakness" },
  { code: "R53.81", description: "Other malaise" },
  { code: "R53.83", description: "Other fatigue" },
  { code: "R54", description: "Age-related physical debility" },
  { code: "R63.0", description: "Anorexia" },
  { code: "R63.4", description: "Abnormal weight loss" },
  { code: "R63.5", description: "Abnormal weight gain" },
  { code: "R63.6", description: "Underweight" },
  { code: "R64", description: "Cachexia" },
  { code: "R13.10", description: "Dysphagia, unspecified" },
  { code: "R13.11", description: "Dysphagia, oral phase" },
  { code: "R13.12", description: "Dysphagia, oropharyngeal phase" },
  { code: "R13.13", description: "Dysphagia, pharyngeal phase" },
  { code: "R13.14", description: "Dysphagia, pharyngoesophageal phase" },
  { code: "R13.19", description: "Other dysphagia" },
  { code: "R47.1", description: "Dysarthria and anarthria" },
  { code: "R47.81", description: "Slurred speech" },
  { code: "R47.89", description: "Other speech disturbances" },
  
  // Care Dependency
  { code: "Z74.01", description: "Bed confinement status" },
  { code: "Z74.09", description: "Other reduced mobility" },
  { code: "Z74.1", description: "Need for assistance with personal care" },
  { code: "Z74.2", description: "Need for assistance at home and no other household member able to render care" },
  { code: "Z74.3", description: "Need for continuous supervision" },
  { code: "Z74.8", description: "Other problems related to care provider dependency" },
  { code: "Z74.9", description: "Problem related to care provider dependency, unspecified" },
  { code: "Z75.5", description: "Holiday relief care" },
  { code: "Z76.2", description: "Encounter for health supervision and care of other healthy infant and child" },
  
  // Falls & Safety
  { code: "R29.6", description: "Repeated falls" },
  { code: "Z91.81", description: "History of falling" },
  { code: "W19.XXXA", description: "Unspecified fall, initial encounter" },
  { code: "W01.0XXA", description: "Fall on same level from slipping, initial encounter" },
  { code: "W18.30XA", description: "Fall on same level, unspecified, initial encounter" },
  
  // GI / Digestive
  { code: "K21.0", description: "Gastro-esophageal reflux disease with esophagitis" },
  { code: "K21.9", description: "Gastro-esophageal reflux disease without esophagitis" },
  { code: "K29.70", description: "Gastritis, unspecified, without bleeding" },
  { code: "K52.9", description: "Noninfective gastroenteritis and colitis, unspecified" },
  { code: "K58.9", description: "Irritable bowel syndrome without diarrhea" },
  { code: "K59.00", description: "Constipation, unspecified" },
  { code: "K59.01", description: "Slow transit constipation" },
  { code: "K59.02", description: "Outlet dysfunction constipation" },
  { code: "K59.04", description: "Chronic idiopathic constipation" },
  { code: "K59.09", description: "Other constipation" },
  { code: "K56.7", description: "Ileus, unspecified" },
  { code: "K74.60", description: "Unspecified cirrhosis of liver" },
  { code: "K76.0", description: "Fatty (change of) liver, not elsewhere classified" },
  { code: "R15.9", description: "Full incontinence of feces" },
  { code: "Z93.3", description: "Colostomy status" },
  { code: "Z93.4", description: "Other artificial openings of gastrointestinal tract status" },
  
  // Other Common
  { code: "E03.9", description: "Hypothyroidism, unspecified" },
  { code: "E05.90", description: "Thyrotoxicosis, unspecified without thyrotoxic crisis" },
  { code: "E66.01", description: "Morbid (severe) obesity due to excess calories" },
  { code: "E66.9", description: "Obesity, unspecified" },
  { code: "E78.00", description: "Pure hypercholesterolemia, unspecified" },
  { code: "E78.5", description: "Hyperlipidemia, unspecified" },
  { code: "E86.0", description: "Dehydration" },
  { code: "E87.1", description: "Hypo-osmolality and hyponatremia" },
  { code: "E87.6", description: "Hypokalemia" },
  { code: "D50.9", description: "Iron deficiency anemia, unspecified" },
  { code: "D64.9", description: "Anemia, unspecified" },
  { code: "D69.6", description: "Thrombocytopenia, unspecified" },
  { code: "B20", description: "Human immunodeficiency virus [HIV] disease" },
  { code: "A41.9", description: "Sepsis, unspecified organism" },
  { code: "R50.9", description: "Fever, unspecified" },
  { code: "R51.9", description: "Headache, unspecified" },
  { code: "R55", description: "Syncope and collapse" },
  { code: "R00.0", description: "Tachycardia, unspecified" },
  { code: "R00.1", description: "Bradycardia, unspecified" },
  { code: "R42", description: "Dizziness and giddiness" },
  { code: "R60.0", description: "Localized edema" },
  { code: "R60.9", description: "Edema, unspecified" },
  
  // Vision & Hearing
  { code: "H54.3", description: "Unqualified visual loss, both eyes" },
  { code: "H54.7", description: "Unspecified visual loss" },
  { code: "H91.90", description: "Unspecified hearing loss, unspecified ear" },
  { code: "H91.93", description: "Unspecified hearing loss, bilateral" },
  
  // Palliative Care
  { code: "Z51.5", description: "Encounter for palliative care" },
  { code: "Z66", description: "Do not resuscitate" },
];

// Format for display
export const formatICD10Option = (item) => `${item.code} - ${item.description}`;

// Search function
export const searchICD10 = (query) => {
  if (!query) return ICD10_CODES.slice(0, 30); // Return first 30 if no query
  
  const lowerQuery = query.toLowerCase();
  return ICD10_CODES.filter(
    (item) =>
      item.code.toLowerCase().includes(lowerQuery) ||
      item.description.toLowerCase().includes(lowerQuery)
  ).slice(0, 30); // Limit results
};
